export const formatMeasureValue = (value: number) => {
  if (value === null || value === 0) {
    return '- cm';
  }
  return `${value} cm`;
};
